import { Injectable, inject } from '@angular/core';
import {  CrudQuery, CrudService } from '@shared/modules/crud/crud.service';
import {  MODELNAME } from './consorcios.config';
import { Observable } from 'rxjs';
import { Expense, SUBCOLLECTION } from './expenses.config';



@Injectable({
    providedIn: 'root',
})
export class ExpensesService {
    model = MODELNAME;
    crudService = inject(CrudService);
    subcollection = SUBCOLLECTION;

     getAllByUser(id: string): Observable<Expense[]> {
            const path = this.subcollection;
            this.crudService.setModel(path);
            const query: CrudQuery = {
                    field: 'administrationUserId',
                    operator: '==',
                    value: id,
                    orderBy: 'createdAt',
                    orderByDirection: 'desc',
                };
                return this.crudService.searchCollectionGroup<Expense>(query);
        }

    create(consorcioId: string, data: any) {
        const path = this.model + '/' + consorcioId + '/' + this.subcollection;
        this.crudService.setModel(path);
        return this.crudService.add(data);
    }

    update(consorcioId: string, id: string, data: any) {
        const path =
            this.model +
            '/' +
            consorcioId +
            '/' +
            this.subcollection +
            '/' +
            id;
        this.crudService.setModel(path);
        return this.crudService.update('', data);
    }

    getAllByConsorcio(consorcioId: string) {
        this.crudService.setModel(
            this.model + '/' + consorcioId + '/' + this.subcollection
        );
        return this.crudService.findAll<any>();
    }

    getSubObjectById(consorcioId: string, id: string) {
        this.crudService.setModel(
            this.model +
                '/' +
                consorcioId +
                '/' +
                this.subcollection +
                '/' +
                id
        );
        return this.crudService.findFirst<any>('');
    }

    delete(consorcioId: string, id: string) {
        const path =
            this.model + '/' + consorcioId + '/' + this.subcollection + '/' + id;
        this.crudService.setModel(path);
        return this.crudService.delete('');
    }
     async countExpenses(consorcioId: string): Promise<number> {
         const path =
            this.model + '/' + consorcioId + '/' + this.subcollection;
        this.crudService.setModel(path);
        const expenses = await this.crudService.countCollection();
        return expenses;
    }
     searchByStatus(adminId: string, status:string) {
         const path =this.subcollection;
        this.crudService.setModel(path);
        const filter:any =[
            {
                field: 'status',
                operator: '==',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]
        
        return  this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }
     searchMultipleByStatus(adminId: string, status:string[]) {
         const path =this.subcollection;
        this.crudService.setModel(path);
        const filter:any =[
            {
                field: 'status',
                operator: 'in',
                value: status,
            },
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]
        
        return  this.crudService.searchCollectionGroupMany<any>(filter, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }

    async countByStatus(filters:{adminId: string, status?:string[]}): Promise<number> {
        const path =this.subcollection;
        this.crudService.setModel(path);

        const query: any[] = [
            {field: 'administrationUserId',
                operator: '==',
                value: filters.adminId
            }
        ];

        if(filters.status){
            query.push({
                field: 'status',
                operator: 'in',
                value: filters.status,
            });
        }
        
        const total = await this.crudService.findWhereGroupCount(query, [{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        },
        {
            orderBy: 'status',
            orderByDirection: 'asc',
        }
    ]);
        return total;
    }

  filter(adminId: string, search:{status: string,consorcioName: string, dateFrom: Date, dateTo: Date}) {
        const path =this.subcollection;
        this.crudService.setModel(path);
            
            const filter:any =[
            {
                field: 'consorcioName',
                operator: '>=',
                value: search.consorcioName,
            },
            {
                field: 'consorcioName',
                operator: '<=',
                value: search.consorcioName + '\uf8ff',
            },
            
            {field: 'administrationUserId',
             operator: '==',
             value: adminId
            }
        ]

               

        if(search.dateFrom){
            filter.push({
                field: 'createdAt',
                operator: '>=',
                value: search.dateFrom,
            })
        }

        if(search.dateTo){
            filter.push({
                field: 'createdAt',
                operator: '<=',
                value: search.dateTo,
            })
        }

        if(search.status){
            filter.push( {
                field: 'status',
                operator: '==',
                value: search.status,
            });
        }

        return this.crudService.searchCollectionGroupMany<any>(filter,[{
            orderBy: 'createdAt',
            orderByDirection: 'desc',
        }]);
    }
}
